// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s23n","newExpiryDate":"styles_newExpiryDate__2OB3n","footer":"styles_footer__1ppdA"};